module.exports = __webpack_public_path__ + "img/image15.2e7e7567.webp";